module.exports = __webpack_public_path__ + "static/media/call_jungles.a40cccd5.jpg";